var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 27",
    height: 27,
    width: 34,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4548"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#141743",
    d: "M1 6.56525V20.4783C1 23.5517 3.49183 26.0435 6.56522 26.0435H27.4348C30.5082 26.0435 33 23.5517 33 20.4783V6.56525",
    id: "Stroke 9692"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#141743",
    d: "M10.7392 17C10.7392 18.9214 9.18237 20.4783 7.26098 20.4783C5.33958 20.4783 3.78271 18.9214 3.78271 17V1H10.7392V17V17Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    id: "Stroke 9693"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#141743",
    d: "M20.4782 17C20.4782 18.9214 18.9214 20.4783 17 20.4783C15.0786 20.4783 13.5217 18.9214 13.5217 17V1H20.4782V17V17Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    id: "Stroke 9694"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#141743",
    d: "M30.2175 17C30.2175 18.9214 28.6606 20.4783 26.7392 20.4783C24.8179 20.4783 23.261 18.9214 23.261 17V1H30.2175V17V17Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    id: "Stroke 9695"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#141743",
    d: "M1 10.7391H3.78261",
    id: "Stroke 9696"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#141743",
    d: "M10.739 10.7391H13.5216",
    id: "Stroke 9697"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#141743",
    d: "M20.4783 10.7391H22.5652",
    id: "Stroke 9698"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#141743",
    d: "M30.2173 10.7391H32.9999",
    id: "Stroke 9699"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#141743",
    d: "M3.78271 7.95654H10.7392",
    id: "Stroke 9709"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#141743",
    d: "M13.5217 7.95654H20.4782",
    id: "Stroke 9710"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#141743",
    d: "M23.261 7.95654H30.2175",
    id: "Stroke 9711"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabs);
export default __webpack_public_path__ + "static/media/labs.fde1eb1b9e29d1d1924d119e448876f8.svg";
export { ForwardRef as ReactComponent };